import { memo } from 'react';
import type { CellThreatGroupProps } from 'src/features/edr/threat/threat.types';
import MitrePopover from '../../MitrePopover';

export type MitreCellProps = {
  mitreTechniques: string[];
};

export const MitreCell = memo(({ mitreTechniques }: MitreCellProps) => {
  return <MitrePopover techniques={mitreTechniques} />;
});

export const renderMitreCell = (info: CellThreatGroupProps<string[]>) => {
  const mitreTechniques = info.getValue();

  return <MitreCell mitreTechniques={mitreTechniques} />;
};
